/**
 * Query hook for the Additional Materials catalog.
 */
import { queryOptions, useQuery } from "@tanstack/react-query"
import { bomQueryKeys } from "@/lib/queryKeys"
import { listLomExtrasFn } from "../server/lomExtras"

export function lomExtrasQueryOptions(configVersionId: string) {
  return queryOptions({
    queryKey: bomQueryKeys.lomExtras(configVersionId),
    queryFn: () => listLomExtrasFn({ data: { configVersionId } }),
    enabled: !!configVersionId,
  })
}

export function useLomExtras(configVersionId: string) {
  return useQuery(lomExtrasQueryOptions(configVersionId))
}
